export default "__VITE_ASSET__BEo2g9Z___"